<div class="post-card" *ngIf="state?.post">
  <div class="santa-flex santa-flex-col santa-w-full">
    <!--  TITLE  -->
    <p class="post-card-title" [ngClass]="state?.titleClasses ?? ''">{{ state?.post?.title }}</p>

    <!--  AUTHOR  -->
    <div class="santa-flex santa-mb-20">
      <alliance-clubs-author [userProfile]="state?.post?.userProfile ?? null" [separator]="'—'"></alliance-clubs-author>
    </div>

    <div class="santa-mt-auto">
      <div class="post-card-separator">
        <!--  TWO LINES SEPARATOR  -->
      </div>
    </div>

    <!--  DATE & VIEWS  -->
    <div class="santa-mt-20 santa-flex santa-text-black-500 santa-justify-between">
      <alliance-clubs-date [date]="state?.post?.publishedAt ?? null"></alliance-clubs-date>
      <alliance-clubs-views [class.santa-ml-20]="state?.post?.publishedAt" class="santa-flex" [views]="state?.post?.viewsCount ?? 0"></alliance-clubs-views>
    </div>
  </div>

  <div class="post-card-image-wrapper" *ngIf="state?.withImg && state?.post?.thumbnail">
    <img width="auto" height="auto" [src]="state?.post?.thumbnail" [alt]="state.imageAttributes.alt" [title]="state.imageAttributes.title" loading="eager" />
  </div>

  <!--  RUBRICS  -->
  <div class="santa-flex santa-mt-20" *ngIf="state?.withRubrics">
    <alliance-clubs-rubrics-list class="santa-flex santa-truncate" [rubrics]="(state?.post?.topics ?? []).slice(0, 2)" [isPromo]="isPromo(state?.post?.tags ?? [])"></alliance-clubs-rubrics-list>
  </div>
</div>
